import React from 'react';
import SelectFilter from './SelectFilter';

export const ENVIRONMENTS = ['All Environments', 'Local', 'Staging', 'Production'];

const EnvironmentFilter = ({ selectedEnvironment, setSelectedEnvironment }) => {
  return (
    <SelectFilter 
      options={ENVIRONMENTS} 
      selectedValue={selectedEnvironment} 
      setSelectedValue={setSelectedEnvironment} 
    />
  );
};

export default EnvironmentFilter; 